import { useTranslation } from 'react-i18next';
import type { CreateSimpleDataRequest } from '#pie/internal/api/pie-bff';
import { typedFormFields } from '#pie/utils/typedFormFields';

const { ConditionalField, FormFileMultiple, FormTextArea } =
  typedFormFields<CreateSimpleDataRequest>();

export function SimpleClarification() {
  // Licht hier je verzoek zo specifiek mogelijk toe
  const { t } = useTranslation('dataRequest');

  return (
    <ConditionalField
      field="description"
      condition={(fieldValue) =>
        !!fieldValue('attributeNote') && fieldValue('attributeNote')!.length > 0
      }
    >
      <FormTextArea
        fullWidth
        label={t('clarification')}
        name="description"
        showWordCount
        rules={{ maxLength: 2000, minLength: 2, required: true }}
      />
      <FormFileMultiple
        label=""
        name="attachments"
        rules={{ required: false }}
      />
    </ConditionalField>
  );
}
